module.exports = __webpack_public_path__ + "static/media/audio-03-tt.3cf7a283.mp3";